import { FC } from 'react';

import { formatPercentage, formatWalletAddress } from 'utils/formatters';

import * as S from './WalletItem.styles';

interface WalletItemProps {
  address: string;
  roi: number;
  onClick?: () => void;
}

export const WalletItem: FC<WalletItemProps> = ({ address, roi, onClick }) => {
  return (
    <S.Container onClick={onClick}>
      <S.Address>{formatWalletAddress(address)}</S.Address>
      <S.Roi>{formatPercentage(roi, { suffix: '% ROI' })}</S.Roi>
    </S.Container>
  );
};
